import React from "react";
import { motion } from "framer-motion";
import "./style.css";
import sponsors from "./sponsors.json";

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08 } },
};

const itemVariants = {
  hidden:  { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } },
};

export default function Sponsors() {
  const record = sponsors.photoset.photo;

  return (
    <section className="sponsors-section" id="sponsors">
      {/* Header */}
      <div className="udg-section-header sponsors-header">
        <motion.span
          className="udg-eyebrow"
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Collaboration
        </motion.span>
        <motion.h2
          className="udg-section-title font-display"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          Our Partners
        </motion.h2>
        <motion.span
          className="udg-gold-rule"
          style={{ margin: "0 auto", transformOrigin: "left" }}
          initial={{ opacity: 0, scaleX: 0 }}
          whileInView={{ opacity: 1, scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.6 }}
        />
      </div>

      {/* Partners grid */}
      <motion.div
        className="sponsors-grid"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-60px" }}
      >
        {record.map((rec, index) => (
          <motion.div key={index} className="sponsor-tile udg-card" variants={itemVariants}>
            {rec.type && (
              <span className="sponsor-type-label">{rec.type}</span>
            )}
            <a
              href={rec.link}
              target="_blank"
              rel="noreferrer"
              className="sponsor-logo-link"
              aria-label={rec.title}
            >
              <img
                src={`https://live.staticflickr.com/${rec.server}/${rec.id}_${rec.secret}.jpg`}
                alt={rec.title}
                className="sponsor-logo-img"
              />
            </a>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
